const FileSaver = require('file-saver');

import util from './_utils';
import lang from './lang';
import aspiration from './aspirations';

const social_button = d3.select('.page--personalize__outside--share'),
	download_button = d3.select('.page--personalize__outside--download'),
	copy_button = d3.select('.page--personalize__outside--copy');

function init() {
	//checkAllImages()
	social_button.on('click', function() {
		const social_button_open = download_button.classed('is-visible');

		if (!social_button_open) {
			show();

			const language = lang.getCurrentLang(),
				story_location = util.getStoryLocation();

			download_button.on('click', function() {
				d3.select(this).classed('is-clicked', true);

				const imgInfo = getImgInfo(language, story_location);
				downloadImg(imgInfo);

				setTimeout(() => {
					d3.select(this).classed('is-clicked', false);
				}, 2000);
			});

			copy_button.on('click', function() {
				d3.select(this).classed('is-clicked', true);

				const linkInfo = getLinkInfo(language, story_location);
				copyURL(linkInfo);

				setTimeout(() => {
					d3.select(this).classed('is-clicked', false);
				}, 2000);
			});

		} else {
			hide();
		}
	})
}

function show() {
	social_button.classed('is-active', true);
	download_button.classed('is-visible', true);
	copy_button.classed('is-visible', true);
}

function hide() {
	social_button.classed('is-active', false);
	download_button.classed('is-visible', false);
	copy_button.classed('is-visible', false);
}

function downloadImg(imgInfo) {
	FileSaver.saveAs(imgInfo.url , imgInfo.name);
}

function copyURL(url) {
	const baseUrl = [
		window.location.protocol,
		'//',
		window.location.host,
		window.location.pathname,
	].join('');

	const fullUrl = baseUrl + url;

	var el = document.createElement('textarea');
	el.value = fullUrl;
	el.setAttribute('readonly', '');
	el.style = {
		position: 'absolute',
		left: '-9999px'
	};
	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
}

function getLinkInfo(language, story_location) {
	const chapter = story_location.current_chapter,
		index = story_location.current_index;

	return `?lang=${language}&chapter=${chapter}`;
}

function getImgInfo(language, story_location) {
	const chapter = story_location.current_chapter,
		index = story_location.current_index;

	let languageFormatted = language.split('-')[1];
	if (languageFormatted === 'BR') languageFormatted = 'PT';
	if (languageFormatted === 'US') languageFormatted = 'EN';

	let startUrl = `/assets/social/Press/${languageFormatted}/`;
	if (languageFormatted === 'EN') startUrl = `/assets/social/Instagram/`;

	let imgName = 'Reasons-for-Running';

	if (chapter === 'core-viz') {
		if (index === 1 || index === 2) {
			imgName = 'Why-We-Start';
		} else {
			imgName = 'Reasons-for-Running';
		}

	} else if (chapter === 'love-hate') {
		if (index === 1) {
			imgName = 'Morning-Alarm';
		} else if (index === 3) {
			imgName = 'Finish-Line'
		} else {
			imgName = 'Love-Hate';
		}

	} else if (chapter === 'health') {
		if (index === 2) {
			imgName = 'Health-Body-Image'
		} else if (index === 3) {
			imgName = 'Health-Strength';
		} else if (index === 4) {
			imgName = 'Health-Anxiety';
		} else {
			imgName = 'Health-Motivator';
		}

	} else if (chapter === 'community') {
		if (index === 2) {
			imgName = 'Running-Clubs'
		} else if (index === 3) {
			imgName = 'Community-Japan';
		} else {
			imgName = 'Who-We-Run-With';
		}

	} else if (chapter === 'routine') {
		if (index === 1) {
			imgName = 'When-Do-We-Run';
		} else if (index === 2) {
			imgName = 'Life-Changes';
		} else {
			imgName = 'Top-Motivation';
		}

	} else if (chapter === 'aspirations') {
		const athlete = aspiration.getAthlete();
		console.log(athlete);

		if (athlete) {
			if (athlete === 'Mirna Valerio') {
				imgName = 'Mirna-Valerio';
			} else if (athlete === 'Martin Yelling, PhD') {
				imgName = 'Martin-Yelling';
			} else if (athlete === 'Mary Kate Callahan') {
				imgName = 'Mary-Kate-Callaghan';
			} else if (athlete === 'Megan Roche') {
				imgName = 'Megan-Roche';
			} else {
				imgName = 'Mary-Kate-Callaghan';
			}
		} else {
			imgName = 'Mary-Kate-Callaghan';
		}
	}

	let baseUrl = [
		window.location.protocol,
		'//',
		window.location.host,
		window.location.pathname,
	].join('');

	if (baseUrl.endsWith('/index.html')) {
		baseUrl = baseUrl.substring(0, baseUrl.indexOf('/index.html'));
	}

	let fullUrl = baseUrl + startUrl + imgName + '.png';
	const imgExists = checkIfImgExists(fullUrl);

	if (!imgExists) {
		fullUrl = baseUrl + `/assets/social/Instagram/Reasons-for-Running.png`,
		imgName = 'Reasons-for-Running';
	};

	return {
		url: fullUrl,
		name: imgName + '.png',
	};
}

function checkIfImgExists(url) {
	var http = new XMLHttpRequest();
	http.open('HEAD', url, false);
	http.send();
	return http.status != 404;
}

function checkAllImages() {
	const langs = ['DE', 'ES', 'FR', 'JP', 'PT', 'EN']
	const imgNames = ['Morning-Alarm', 'Finish-Line', 'Love-Hate', 'Reasons-for-Running', 'Why-We-Start', 'Health-Anxiety', 'Health-Strength', 'Health-Body-Image', 'Health-Motivator', 'Top-Motivation', 'When-Do-We-Run', 'Life-Changes', 'Who-We-Run-With', 'Running-Clubs', 'Community-Japan'];

	let baseUrl = [
		window.location.protocol,
		'//',
		window.location.host,
		window.location.pathname,
	].join('');

	if (baseUrl.endsWith('/index.html')) {
		baseUrl = baseUrl.substring(0, baseUrl.indexOf('/index.html'));
	}

	langs.forEach(lang => {
		let startUrl = `/assets/social/Press/${lang}/`;
		if (lang === 'EN') startUrl = `/assets/social/Instagram/`;

		imgNames.forEach(imgName => {
			let fullUrl = baseUrl + startUrl + imgName + '.png';
			const imgExists = checkIfImgExists(fullUrl);

			if (!imgExists) console.log(fullUrl);
		})
	})
}

export default {
	init,
	hide,
	show,
}